import { Grid } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import { ConfigurationContext } from '../../../../context api/Configuration/ConfigurationContext'
import { useRegion } from '../../../../hooks/CompanyConfiguration/useRegion'
import { useLocation } from '../../../../hooks/Location/useLocation'
import { sortByName } from '../../../../shared/constants'
import CustomInput from '../../../CustomInput'
import CustomSelect from '../../../CustomSelect'
import SwitchStatus from '../../../SwitchStatus'

function EditAreaComp({ state, setState }) {
  const { name, region, zone, state1, district, city: cityNew, areaCode } = state

  //console.log('STATE AREA : ', state)

  const { getAllRegion } = useRegion()
  const { regions } = useContext(ConfigurationContext)

  const { zones, getAllZone, getAllState, states, districts, getAllDistrict, getAllCity, city } = useLocation()

  //console.log('CITY : ', city)
  useEffect(() => {
    getAllRegion()
    // getAllZone()
    // getAllStates()
  }, [])

  useEffect(() => {
    if (region) {
      getAllZone({ region: region })
    }
    if (zone) {
      getAllState({ region: region, zone: zone })
    }
    if (state1) {
      getAllDistrict({
        region: region,
        zone: zone,
        state: state1,
      })
    }
    if (district) {
      getAllCity({ region: region, zone: zone, state: state1, district: district })
    }
  }, [region, zone, state1, district])

  const data = [
    { label: 'Area Code', value: areaCode, name: 'areaCode' },
    { label: 'Name', value: name, name: 'name' },
    { label: 'Region', value: region, name: 'region', select: true, options: sortByName(regions) },
    { label: 'Zone', value: zone, name: 'zone', select: true, options: sortByName(zones) },
    { label: 'State', value: state1, name: 'state1', select: true, options: sortByName(states) },
    { label: 'District', value: district, name: 'district', select: true, options: sortByName(districts) },
    { label: 'City', value: cityNew, name: 'city', select: true, options: sortByName(city) },
  ]
  return (
    <Grid container>
      {data.map((item, index) =>
        item.select ? (
          <Grid item lg={4}>
            <CustomSelect
              label={item.label}
              button={item.button}
              options={item.options}
              value={item.value}
              // handleChange={item.handleChange}
              form={state}
              setForm={setState}
              formCheck={true}
              name={item.name}
              disabled={item.disabled}
            />
          </Grid>
        ) : (
          <Grid item lg={4}>
            <CustomInput
              label={item.label}
              icon={item.icon}
              name={item.name}
              value={item.value}
              number={item.number ? true : false}
              //   form={targetForm}
              //   setForm={setTargetForm}
              form={state}
              setForm={setState}
              formCheck={true}
              type={item.type}
            />
          </Grid>
        )
      )}
      <SwitchStatus form={state} setForm={setState} value={state.active} />
    </Grid>
  )
}

export default EditAreaComp
